import actions from './breadcrumbs-actions-creator';

export function updateBreadcrumbsFromRoute(details){
  return (dispatch) => dispatch(actions.updateBreadcrumbsFromRoute(details));
}
